var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossCheckOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8062_2768",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3865 6.86321C19.738 7.21469 19.738 7.78453 19.3865 8.13601L10.3865 17.136C10.035 17.4875 9.46517 17.4875 9.1137 17.136L4.6137 12.636C4.26223 12.2845 4.26223 11.7147 4.6137 11.3632C4.96517 11.0117 5.53502 11.0117 5.88649 11.3632L9.7501 15.2268L18.1137 6.86321C18.4652 6.51174 19.035 6.51174 19.3865 6.86321Z",
    fill: "#1B1C1E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8062_2768)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#FF7B2E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCheckOn);
export default __webpack_public_path__ + "static/media/crossCheckOn.7896c338f3aaec50385a28821a730195.svg";
export { ForwardRef as ReactComponent };